/* ============================================================
   Shopailo — custom.js   (loaded after theme.js)

   Keeps the "Bundle & save" cards and the Save % badge in sync
   with what the shopper has actually selected.

   Two bugs this repairs, both in sections/main-product.liquid:

   1. Each bundle card is priced in Liquid from
      product.selected_or_first_available_variant, so the numbers are
      frozen at page load. theme.js repoints the variant id, the main
      price and the sticky bar on a swatch tap, but nothing recomputed
      the bundle cards — switching 3 / 6 / 12 blades pack left the
      bundle maths on the old set.

   2. A bundle can hold one dropdown PER UNIT so sets can be mixed, but
      the card price was variant.price * qty — a single set counted qty
      times — and only the first dropdown was wired to anything. Buy 2
      of "3 blades + 6 blades" priced as two 3-blade packs.

   So a card's total is the SUM of the units actually chosen in it,
   with the card's discount applied to that sum.
   ============================================================ */
(function () {
  "use strict";

  /* Mirrors the "Save %" range setting on the bundle block (0-50, step 5). */
  var SAVE_STEPS = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

  var state = null;
  var bound = false;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  /* Rendered money string -> integer cents. null when it can't be read. */
  function parseMoney(text) {
    var s = String(text == null ? "" : text).replace(/&[^;\s]{1,8};/g, " ");
    var m = s.match(/\d[\d.,\s]*/);
    if (!m) return null;
    var n = m[0].replace(/\s/g, "");
    var pos = Math.max(n.lastIndexOf("."), n.lastIndexOf(","));
    var cents;
    if (pos > -1 && n.length - pos - 1 === 2) {
      cents = parseInt(n.slice(0, pos).replace(/[.,]/g, ""), 10) * 100 +
              parseInt(n.slice(pos + 1), 10);
    } else {
      cents = parseInt(n.replace(/[.,]/g, ""), 10) * 100;
    }
    return isFinite(cents) ? cents : null;
  }

  /* The same integer maths Liquid does: full | times: pct | divided_by: 100 */
  function discounted(full, savePct) {
    return full - Math.floor((full * savePct) / 100);
  }

  function compareOf(price, compareAt) {
    return (compareAt && compareAt > price) ? compareAt : price;
  }

  function build() {
    state = null;

    var dataEl = document.querySelector('script[type="application/json"][id^="ProductVariants-"]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent || "[]"); } catch (e) { return; }
    if (!variants.length) return;

    var form = document.querySelector("[data-product-form]");
    var idInput = form ? form.querySelector("[name='id']") : null;
    if (!idInput) return;

    /* The section already publishes value -> price for the per-unit dropdowns. */
    var byValue = {};
    var colorsEl = document.querySelector('script[type="application/json"][id^="BundleColors-"]');
    if (colorsEl) {
      try {
        JSON.parse(colorsEl.textContent || "[]").forEach(function (c) { byValue[c.value] = c; });
      } catch (e) { /* fall back to scanning variants */ }
    }

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* One dropdown's option value -> what that single unit costs. */
    function unitOf(value) {
      var c = byValue[value];
      if (c && typeof c.price_raw === "number") {
        return { price: c.price_raw, compare: compareOf(c.price_raw, c.compare_raw) };
      }
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.option1 === value || v.option2 === value || v.option3 === value) {
          return { price: v.price, compare: compareOf(v.price, v.compare_at_price) };
        }
      }
      return null;
    }

    /* What Liquid rendered the page with. */
    var base = variantById(idInput.value);
    if (!base) return;

    /* One-time calibration.
       A card's "Save %" lives in the section's block settings and never
       reaches the browser. Recover it by finding the single allowed step
       that exactly reproduces the price Liquid already printed. Liquid
       priced the card as base.price * qty, so calibrate against that —
       never against the dropdowns, whose values a browser may have
       restored on a soft reload. If no step reproduces the printed price,
       or more than one does, that card is left alone rather than guessed
       at, so a bad read can never invent a price. */
    var cards = [];
    var bundles = document.querySelector("[data-bundles]");
    if (bundles) {
      Array.prototype.forEach.call(bundles.querySelectorAll(".bundle"), function (card) {
        var strong = card.querySelector(".bundle__price strong");
        if (!strong) return;
        var shown = parseMoney(strong.textContent);
        if (shown === null) return;

        var qty = parseInt(card.getAttribute("data-bundle-qty"), 10) || 1;
        var full = base.price * qty;

        var save = null;
        for (var i = 0; i < SAVE_STEPS.length; i++) {
          if (discounted(full, SAVE_STEPS[i]) === shown) {
            if (save !== null) { save = null; break; }
            save = SAVE_STEPS[i];
          }
        }
        if (save === null) return;

        cards.push({
          qty: qty,
          save: save,
          strong: strong,
          wrap: strong.parentNode,
          compare: card.querySelector(".bundle__price s"),
          selects: card.querySelectorAll("[data-color-select]")
        });
      });
    }

    state = { variants: variants, variantById: variantById, unitOf: unitOf, idInput: idInput, cards: cards };
    reprice(base);
  }

  function reprice(v) {
    if (!state || !v) return;

    state.cards.forEach(function (c) {
      var full = 0;
      var compare = 0;
      var summed = false;

      /* Mixed sets are the normal case here, so total the units one by one.
         If any dropdown can't be resolved, fall back to the flat
         variant * qty rather than showing a half-counted total. */
      if (c.selects.length) {
        summed = true;
        for (var i = 0; i < c.selects.length; i++) {
          var u = state.unitOf(c.selects[i].value);
          if (!u) { summed = false; break; }
          full += u.price;
          compare += u.compare;
        }
      }

      if (!summed) {
        full = v.price * c.qty;
        compare = compareOf(v.price, v.compare_at_price) * c.qty;
      }

      var price = discounted(full, c.save);
      c.strong.innerHTML = money(price);

      if (compare > price) {
        if (!c.compare) {
          c.compare = document.createElement("s");
          c.wrap.appendChild(c.compare);
        }
        c.compare.innerHTML = money(compare);
        c.compare.style.display = "";
      } else if (c.compare) {
        c.compare.style.display = "none";
      }
    });

    /* The main price block's "Save X%" badge is rendered in Liquid too, so it
       goes stale the same way. theme.js updates the price and the strike but
       not this. */
    var baseCompare = compareOf(v.price, v.compare_at_price);
    document.querySelectorAll(".price").forEach(function (block) {
      var badge = block.querySelector(".price__save");
      var pct = baseCompare > v.price
        ? Math.floor(((baseCompare - v.price) * 100) / baseCompare)
        : 0;

      if (!pct) { if (badge) badge.style.display = "none"; return; }

      if (!badge) {
        badge = document.createElement("span");
        badge.className = "price__save";
        block.appendChild(badge);
      }
      badge.textContent = "Save " + pct + "%";
      badge.style.display = "";
    });
  }

  /* theme.js owns [name="id"]. Read it back on the next tick so this runs
     after its click handler regardless of which listener bound first. */
  function syncSoon() {
    setTimeout(function () {
      if (state) reprice(state.variantById(state.idInput.value));
    }, 0);
  }

  function init() {
    build();
    if (bound) return;
    bound = true;

    document.addEventListener("click", function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(".variant-swatch")) syncSoon();
    });
    /* Every unit dropdown matters now, not just the first in a card. */
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (t && t.matches && t.matches("[data-color-select]")) syncSoon();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
